import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../utils/checkout';
interface CheckoutButtonProps {
  label: string;
  sub?: string;
  id?: string;
  variant?: 'primary' | 'light';
}
export function CheckoutButton({
  label,
  sub,
  id,
  variant = 'primary'
}: CheckoutButtonProps) {
  const base = 'group flex w-full items-center justify-center gap-2 rounded-2xl px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide transition-[transform,background-color,box-shadow] duration-150 ease-out active:scale-[0.98] sm:text-lg';
  const styles = variant === 'primary' ? 'bg-aqua-500 text-white shadow-cta hover:bg-aqua-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-aqua-300' : 'bg-white text-navy-800 shadow-card hover:bg-aqua-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white';
  return <div id={id} className="mx-auto w-full max-w-md" data-id="element-20" data-mp="4rn476iwqcts">
      <a href={CHECKOUT_URL} className={`${base} ${styles}`} data-id="element-21" data-mp="4qvhkl7afpfn">
        <span data-id="element-22" data-mp="9r9izkedw14p">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-23" data-mp="9rja5bb60ebz" />
      </a>
      {sub ? <p className={`mt-3 text-center text-[12.5px] font-medium leading-snug sm:text-sm ${variant === 'primary' ? 'text-navy-800/70' : 'text-white/75'}`} data-id="element-24" data-mp="3vyzqfzyndggk">
          {sub}
        </p> : null}
    </div>;
}